<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group label-for="nomor-kkprl">
          <template #label>Nomor KKPRL <span class="text-danger">*</span></template>
          <b-form-input
            id="nomor-kkprl"
            :value="value.nomor_kkprl"
            type="text"
            @input="updateField('nomor_kkprl', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="jenis-kegiatan">
          <template #label>Jenis Kegiatan <span class="text-danger">*</span></template>
          <v-select
            id="jenis-kegiatan"
            :value="value.jenis_kegiatan"
            :options="jenisKegiatanOptions"
            placeholder="Pilih Jenis Kegiatan"
            @input="updateField('jenis_kegiatan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="npwp">
          <template #label>NPWP <span class="text-danger">*</span></template>
          <b-form-input
            id="npwp"
            :value="value.npwp"
            type="text"
            v-mask="'##.###.###.#-###.####'"
            @input="updateField('npwp', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="subjek-hukum">
          <template #label>Subjek Hukum <span class="text-danger">*</span></template>
          <b-form-input
            id="subjek-hukum"
            :value="value.subjek_hukum"
            type="text"
            @input="updateField('subjek_hukum', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="value.jenis_kegiatan === 'Berusaha'" md="6">
        <b-form-group label-for="nib">
          <template #label>NIB <span class="text-danger">*</span></template>
          <b-form-input id="nib" :value="value.nib" type="text" @input="updateField('nib', $event)" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="provinsi">
          <template #label>Provinsi <span class="text-danger">*</span></template>
          <v-select
            id="provinsi"
            :value="value.provinsi"
            :options="provinsiOptions"
            :reduce="(provinsi) => provinsi.nama_provinsi"
            label="nama_provinsi"
            multiple
            placeholder="Pilih Provinsi (bisa lebih dari satu)"
            :disabled="isLoadingProvinsi"
            @input="updateField('provinsi', $event)"
          />
          <small v-if="isLoadingProvinsi" class="text-muted">Memuat daftar provinsi...</small>
          <small v-else-if="provinsiError" class="text-danger">{{ provinsiError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="tanggal-terbit">
          <template #label>Tanggal Terbit <span class="text-danger">*</span></template>
          <b-form-input
            id="tanggal-terbit"
            :value="value.tanggal_terbit"
            type="date"
            @input="updateField('tanggal_terbit', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-kegiatan">
          <template #label>Nama Kegiatan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-kegiatan"
            :value="value.nama_kegiatan"
            type="text"
            @input="updateField('nama_kegiatan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-detail-kegiatan">
          <template #label>Nama Detail Kegiatan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-detail-kegiatan"
            :value="value.nama_detail_kegiatan"
            type="text"
            @input="updateField('nama_detail_kegiatan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="luas">
          <template #label>Luas <span class="text-danger">*</span></template>
          <b-input-group append="ha">
            <b-form-input id="luas" :value="value.luas" type="text" @input="updateField('luas', $event)" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="panjang">
          <template #label>Panjang <span class="text-danger">*</span></template>
          <b-input-group append="m">
            <b-form-input id="panjang" :value="value.panjang" type="text" @input="updateField('panjang', $event)" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-perairan">
          <template #label>Nama Perairan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-perairan"
            :value="value.nama_perairan"
            type="text"
            @input="updateField('nama_perairan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-kawasan-rtr">
          <template #label>Nama Kawasan RTR <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-kawasan-rtr"
            :value="value.nama_kawasan_rtr"
            type="text"
            @input="updateField('nama_kawasan_rtr', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="dasar-hukum-rtr">
          <template #label>Dasar Hukum RTR <span class="text-danger">*</span></template>
          <b-form-input
            id="dasar-hukum-rtr"
            :value="value.dasar_hukum_rtr"
            type="text"
            @input="updateField('dasar_hukum_rtr', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="keterangan-realisasi">
          <template #label>Keterangan Realisasi <span class="text-danger">*</span></template>
          <b-form-input
            id="keterangan-realisasi"
            :value="value.keterangan_realisasi"
            type="text"
            @input="updateField('keterangan_realisasi', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="bukti-dukung">
          <template #label>Bukti Dukung (PDF) <span class="text-danger">*</span></template>
          <div class="d-flex align-items-center">
            <b-form-file
              id="bukti-dukung"
              :value="value.bukti_dukung"
              accept=".pdf,application/pdf"
              placeholder="Pilih file PDF"
              drop-placeholder="Letakkan file PDF di sini"
              plain
              class="form-control"
              @input="updateField('bukti_dukung', $event)"
            />
            <b-button
              variant="success"
              class="ml-2 text-nowrap"
              :disabled="!value.id_file_bukti_dukung"
              @click="unduhBuktiDukung"
            >
              <i class="fa fa-download"></i> Unduh
            </b-button>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex align-items-center justify-content-between mb-2 mt-4">
      <h5 class="mb-0">Titik Koordinat <span class="text-danger">*</span></h5>
      <div>
        <span v-b-tooltip.hover :title="tooltipTitikKoordinat">
          <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            :disabled="!hasIdPelaksanaanPenilaian"
            @click="tambahTitik"
          >
            <i class="fa fa-plus"></i> Tambah Titik
          </b-button>
        </span>
        <span v-b-tooltip.hover :title="tooltipTitikKoordinat">
          <b-button size="sm" variant="primary" :disabled="!hasIdPelaksanaanPenilaian" @click="showImportModal = true">
            <i class="fa fa-upload"></i> Import Titik
          </b-button>
        </span>
      </div>
    </div>

    <div class="table-responsive mb-0 datatables">
      <b-table
        striped
        hover
        :items="itemsWithNumber"
        :fields="fields"
        responsive="sm"
        show-empty
        empty-text="Belum ada titik koordinat."
      >
        <template #head(bujur)> Bujur <span class="text-danger">*</span> </template>
        <template #head(lintang)> Lintang <span class="text-danger">*</span> </template>
        <template #head(observasi)> Observasi Titik Pengendalian <span class="text-danger">*</span> </template>
        <template #cell(bujur)="data">
          <b-form-input
            :value="data.item.bujur"
            type="text"
            :aria-label="`Bujur titik ${data.item.nomor}`"
            @input="updatePoint(data.item.id, 'bujur', $event)"
          />
        </template>
        <template #cell(lintang)="data">
          <b-form-input
            :value="data.item.lintang"
            type="text"
            :aria-label="`Lintang titik ${data.item.nomor}`"
            @input="updatePoint(data.item.id, 'lintang', $event)"
          />
        </template>
        <template #cell(observasi)="data">
          <b-form-radio-group
            :id="`observasi-${data.item.id}`"
            :checked="data.item.observasi"
            :options="observasiOptions"
            :name="`observasi-${data.item.id}`"
            @input="updatePoint(data.item.id, 'observasi', $event)"
          />
        </template>
        <template #cell(aksi)="data">
          <b-button size="sm" variant="danger" class="text-white" @click="hapusTitik(data.item.id)">
            <i class="fa fa-trash"></i> Hapus
          </b-button>
        </template>
      </b-table>
    </div>

    <b-modal v-model="showImportModal" title="Import Titik Koordinat" hide-footer @hidden="resetImport" scrollable>
      <template>
        <b-form-group label-for="import-koordinat-file">
          <template #label>File Excel <span class="text-danger">*</span></template>
          <b-form-file
            id="import-koordinat-file"
            v-model="importFile"
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            placeholder="Pilih file Excel"
            drop-placeholder="Letakkan file Excel di sini"
            plain
            class="form-control"
          />
        </b-form-group>
        <a class="btn btn-outline-primary btn-sm mb-3" href="/template/format_import_titik_koordinat.xlsx" download>
          <i class="fa fa-download"></i> Unduh Template
        </a>
        <b-alert show variant="warning"> Import titik koordinat akan menimpa data titik koordinat lama. </b-alert>
        <b-alert v-if="importError" show variant="danger">{{ importError }}</b-alert>
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-2" @click="showImportModal = false">Batal</b-button>
          <b-button variant="primary" :disabled="!importFile || isImporting" @click="importKoordinat">
            {{ isImporting ? 'Memproses...' : 'Import' }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div>
        <b-button variant="success" class="mr-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import vSelect from 'vue-select'
import api from '@/services/api'

export default {
  name: 'FormIdentitasPusat',
  components: { vSelect },
  props: {
    value: {
      type: Object,
      default: () => ({
        nomor_kkprl: '',
        jenis_kegiatan: '',
        npwp: '',
        subjek_hukum: '',
        nib: '',
        provinsi: [],
        tanggal_terbit: '',
        nama_kegiatan: '',
        nama_detail_kegiatan: '',
        luas: '',
        panjang: '',
        nama_perairan: '',
        nama_kawasan_rtr: '',
        dasar_hukum_rtr: '',
        keterangan_realisasi: '',
        bukti_dukung: null,
        id_file_bukti_dukung: null,
        titik_koordinat: [],
      }),
    },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      provinsiOptions: [],
      jenisKegiatanOptions: ['Berusaha', 'Non Berusaha'],
      isLoadingProvinsi: false,
      provinsiError: '',
      nextPointId: 1,
      showImportModal: false,
      importFile: null,
      importError: '',
      isImporting: false,
      savedPointsById: {},
      isSavingPoints: false,
      observasiOptions: [
        { text: 'Sesuai', value: 'Sesuai' },
        { text: 'Tidak Sesuai', value: 'Tidak Sesuai' },
      ],
      fields: [
        { key: 'nomor', label: 'Nomor' },
        { key: 'bujur', label: 'Bujur' },
        { key: 'lintang', label: 'Lintang' },
        { key: 'observasi', label: 'Observasi Titik Pengendalian' },
        { key: 'aksi', label: 'Aksi' },
      ],
    }
  },
  computed: {
    itemsWithNumber() {
      return this.value.titik_koordinat.map((point, index) => ({ ...point, nomor: index + 1 }))
    },
    idPelaksanaanPenilaian() {
      return this.$route.query.id_pelaksanaan_penilaian || ''
    },
    hasIdPelaksanaanPenilaian() {
      return Boolean(this.idPelaksanaanPenilaian)
    },
    tooltipTitikKoordinat() {
      return this.hasIdPelaksanaanPenilaian ? '' : 'Simpan data identitas terlebih dahulu'
    },
  },
  mounted() {
    this.syncSnapshotFromValue()
    this.getProvinsi()
  },
  methods: {
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    emitPoints(points) {
      this.$emit('input', { ...this.value, titik_koordinat: points })
    },
    syncSnapshotFromValue(pointsData) {
      const points = pointsData || this.value.titik_koordinat || []

      this.savedPointsById = points.reduce((result, point) => {
        result[point.id] = { ...point }
        return result
      }, {})
      this.nextPointId = points.reduce((maxId, point) => Math.max(maxId, Number(point.id) || 0), 0) + 1
    },
    tambahTitik() {
      const point = {
        id: this.nextPointId++,
        nama_titik: '',
        bujur: '',
        lintang: '',
        observasi: '',
      }
      this.emitPoints([...this.value.titik_koordinat, point])
    },
    updatePoint(pointId, field, fieldValue) {
      const points = this.value.titik_koordinat.map((point) =>
        point.id === pointId ? { ...point, [field]: fieldValue } : point,
      )
      this.emitPoints(points)
    },
    isPointComplete(point) {
      return (
        String(point.bujur || '').trim() !== '' &&
        String(point.lintang || '').trim() !== '' &&
        ['Sesuai', 'Tidak Sesuai'].includes(point.observasi)
      )
    },
    hasPointChanged(point, index) {
      const saved = this.savedPointsById[point.id]
      if (!saved) return true

      return (
        String(saved.nama_titik) !== String(index + 1) ||
        String(saved.bujur) !== String(point.bujur) ||
        String(saved.lintang) !== String(point.lintang) ||
        saved.observasi !== point.observasi
      )
    },
    buildTitikPayload(point, index, idPelaksanaan) {
      return {
        id_pelaksanaan_penilaian: idPelaksanaan,
        nama_titik: String(index + 1),
        bujur: String(point.bujur),
        lintang: String(point.lintang),
        observasi_titik_pengendalian: point.observasi,
      }
    },
    async simpanTitikKoordinat(id) {
      const idPelaksanaan = id || this.idPelaksanaanPenilaian
      const points = this.value.titik_koordinat || []
      const incompleteIndex = points.findIndex((point) => !this.isPointComplete(point))

      if (incompleteIndex !== -1) {
        Swal.fire('Belum Lengkap', `Titik koordinat nomor ${incompleteIndex + 1} belum lengkap.`, 'warning')
        return false
      }

      this.isSavingPoints = true
      try {
        for (const [index, point] of points.entries()) {
          const isNew = !this.savedPointsById[point.id]
          if (!isNew && !this.hasPointChanged(point, index)) continue

          const payload = this.buildTitikPayload(point, index, idPelaksanaan)

          if (isNew) {
            await api.post('api/titik_koordinat_observasi', payload)
          } else {
            await api.put(`api/titik_koordinat_observasi/${point.id}`, payload)
          }
        }

        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan titik koordinat'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.isSavingPoints = false
      }
    },
    async hapusTitik(pointId) {
      const point = this.value.titik_koordinat.find((item) => item.id === pointId)
      if (!point) return

      const isSaved = Boolean(this.savedPointsById[pointId])

      if (isSaved) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Hapus Titik Koordinat?',
          text: 'Titik koordinat yang dihapus tidak dapat dikembalikan.',
          showCancelButton: true,
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal',
        })
        if (!result.isConfirmed) return

        try {
          await api.delete(`api/titik_koordinat_observasi/${pointId}`)
          this.$delete(this.savedPointsById, pointId)
        } catch (error) {
          const message = error.response?.data?.message || 'Gagal menghapus titik koordinat'
          Swal.fire('Gagal', message, 'error')
          return
        }
      }

      this.emitPoints(this.value.titik_koordinat.filter((item) => item.id !== pointId))
    },
    resetImport() {
      this.importFile = null
      this.importError = ''
      this.isImporting = false
    },
    async importKoordinat() {
      if (!this.importFile) {
        this.importError = 'Pilih file Excel terlebih dahulu.'
        return
      }

      const id = this.idPelaksanaanPenilaian
      if (!id) {
        this.importError = 'Simpan data identitas terlebih dahulu.'
        return
      }

      const result = await Swal.fire({
        icon: 'warning',
        title: 'Import Titik Koordinat',
        text: 'Import titik koordinat akan menimpa data titik koordinat lama, termasuk perubahan yang belum disimpan.',
        showCancelButton: true,
        confirmButtonText: 'Ya, Import',
        cancelButtonText: 'Batal',
      })
      if (!result.isConfirmed) return

      this.isImporting = true
      this.importError = ''
      try {
        const formData = new FormData()
        formData.append('file', this.importFile)

        await api.post(`api/pelaksanaan_penilaian/${id}/titik-koordinat-observasi/import`, formData)

        this.showImportModal = false
        this.$emit('reload')
        Swal.fire('Berhasil', 'Titik koordinat berhasil diimpor', 'success')
      } catch (error) {
        this.importError = error.response?.data?.message || 'Import titik koordinat gagal'
      } finally {
        this.isImporting = false
      }
    },
    async unduhBuktiDukung() {
      const id = this.value.id_file_bukti_dukung
      if (!id) return

      try {
        const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
        const fileURL = URL.createObjectURL(new Blob([res.data], { type: res.data.type }))
        window.open(fileURL, '_blank')
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal mengunduh bukti dukung'
        Swal.fire('Gagal', message, 'error')
      }
    },
    async getProvinsi() {
      this.isLoadingProvinsi = true
      this.provinsiError = ''
      try {
        const response = await axios.get(this.baseapiPengendalian + 'api/provinsi?sort=id,ASC&limit=0', {
          headers: { Authorization: `Bearer ${this.user.accessToken}` },
        })
        this.provinsiOptions = response.data.data || []
      } catch (error) {
        this.provinsiError = 'Daftar provinsi gagal dimuat.'
      } finally {
        this.isLoadingProvinsi = false
      }
    },
  },
}
</script>
